import React, { useRef, useState } from "react";
import saveimg from "../../Assets/downloadcv.png";
import print from "../../Assets/print.svg";
import { Paper } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
const MapSearch = ({
  handlePrint,
  handleToPDF,
  headerSearchData,
  setheaderSearchData,
  handleApply,
  isMobile,
}) => {
  const emtySearchdata = () => {
    setheaderSearchData("");
  };

  return (
    <div className="map-search-print-pdf">
      <div className="map-search-btn">
        <Paper
          className="full-searchbar"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
          }}
        >
          <SearchIcon className="searchicon-in-header" />
          <InputBase
            value={headerSearchData}
            onChange={(e) => {
              const inputValue = e.target.value;
              setheaderSearchData(inputValue);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleApply();
              }
            }}
            className="search-inner-text"
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search..."
            inputProps={{ "aria-label": "Search google maps" }}
            autoComplete="off"
          />
          <div onClick={emtySearchdata} className="cross-icon-prospect-search">
            {headerSearchData && (
              <CloseIcon className="showicons-search" />
            )}{" "}
          </div>
        </Paper>
      </div>
      {!isMobile ? (
        <div className="AllAi-paths-button">
          <div className="download-icon-path" onClick={handlePrint}>
            <img src={print} alt="" className="print-img-aipath-table" />
          </div>
          <div className="download-icon-path" onClick={handleToPDF}>
            <img src={saveimg} alt="" />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default MapSearch;
